import { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import AuthPage from './components/AuthPage';
import AdminDashboard from './components/Admindashboard';
import Reporting from './components/Reporting';
import AlarmsView from './components/AlarmsView.jsx';
import DevToolsPanel from './components/DevToolsPanel.jsx';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem('token')
  );
  const [showAdmin, setShowAdmin] = useState(false);
  const [showReporting, setShowReporting] = useState(false);
  const [showAlarms, setShowAlarms] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    setIsAuthenticated(false);
    setShowAdmin(false);
    setShowReporting(false);
    setShowAlarms(false);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  const isAdmin = user?.globalRole === 'admin' || user?.globalRole === 'superadmin';
  const hasAlarms = isAdmin || !!user?.features?.alarms;

  if (!isAuthenticated) {
    return <AuthPage onAuth={() => setIsAuthenticated(true)} />;
  }

  if (showAdmin && isAdmin) {
    return (
      <AdminDashboard onBack={() => setShowAdmin(false)} />
    );
  }

  if (showReporting) {
    return (
      <Reporting onBack={() => setShowReporting(false)} />
    );
  }

  if (showAlarms && hasAlarms) {
    return (
      <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#e4e6eb' }}>
        <div style={{
          padding: '12px 20px', borderBottom: '1px solid #1e2530',
          display: 'flex', alignItems: 'center', gap: 12
        }}>
          <button
            onClick={() => setShowAlarms(false)}
            style={{
              background: 'transparent', border: '1px solid #2a3441',
              color: '#9aa4b2', padding: '6px 12px', borderRadius: 4, cursor: 'pointer'
            }}
          >← Back</button>
          <h2 style={{ margin: 0, fontSize: 16 }}>Alarms</h2>
        </div>
        <AlarmsView />
      </div>
    );
  }

  return (
    <>
      <Dashboard
        onLogout={handleLogout}
        onReporting={() => setShowReporting(true)}
        onAlarms={() => setShowAlarms(true)}
        onAdmin={isAdmin ? () => setShowAdmin(true) : null}
      />
      {/* Self-gating: renders nothing unless this instance runs ENABLE_DEV_TOOLS
          and the user has a dev role (staging dev console only). */}
      <DevToolsPanel onUnverified={handleLogout} />
    </>
  );
}

export default App;
